import $foreign from "./foreign.cjs";
var bind_ = $foreign.bind_;
var $$for = $foreign.for;
var foreach = $foreign.foreach;
var map_ = $foreign.map_;
var modifyImpl = $foreign.modifyImpl;
var $$new = $foreign.new;
var pure_ = $foreign.pure_;
var read = $foreign.read;
var run = $foreign.run;
var $$while = $foreign.while;
var write = $foreign.write;
export { bind_, $$for as for, foreach, map_, modifyImpl, $$new as new, pure_, read, run, $$while as while, write };
